export enum ChatState {
  Initial,
  Connecting,
  Connected,
  Ready,
  Error,
}

interface ChatMessageSender {
  id: number;
  name: string | undefined;
  avatarLink: string | undefined;
  role: string | undefined;
  // TODO change tags type to just 'string[]' after new chat release is done
  tags: string[] | undefined;
}

export interface ChatMessageBasic {
  id: number | string;
  timestamp: number;
  sender: ChatMessageSender;
  text: string;
}

export enum ChatMessageStatus {
  Approved = 'approved',
  Pending = 'pending',
  Rejected = 'rejected',
}

export interface ChatMessage extends ChatMessageBasic {
  /** @deprecated remove when cleaning old broadcast */
  isNew: boolean;
  status: ChatMessageStatus;
  shouldAnimate?: boolean;
}

/**
 * Payload of the `chat_connection_details` websocket message (and the pull-token endpoint
 * response): everything the Ably-backed chat provider needs to connect to the broadcast room.
 */
export interface ChatConnectionDetails {
  roomId: string;
  channel: string;
  token: string;
  refreshToken: string;
  refreshUrl: string | null;
  encryptionKeyId: string;
  encryptionKey: string;
  expiresAt: number;
  sessionExpiresAt: number;
  /** Chat role (moderator/participant) — drives capabilities, not the audience-panel subtitle. */
  role: string;
  actions: string[];
  displayName: string | null;
  avatarUrl: string | null;
  /** Member's descriptive community role (e.g. "QA"), shown in the audience panel. */
  memberRole: string | null;
}
